import React, { useEffect, useState } from "react";
import { Button, Checkbox, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { EyeFilled } from "@ant-design/icons";
import "../../css/common.css";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { formatDate } from "../../../utils/dateFormatter";

const ListOilRecordLog = () => {
  const navigate = useNavigate();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [ship_id, set_ship_id] = useState("");
  const [ship_table_list, set_ship_table_list] = useState([]);

  const SHIP_LIST_API = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_ship_table_list(res?.ships);
          set_ship_id(res?.ships[0]?.id);
          LIST_OIL_RECORD_LOGBOOK_API(res?.ships[0]?.id);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
    }
  };

  const LIST_OIL_RECORD_LOGBOOK_API = (ship_id) => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", ship_id);
      FORM_DATA.append("orb_part", "1");
      post(ApiURL.company_listing_orb_records, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const reversedData = res.records?.map((item) => ({
            ...item,
            key: item.record_id.toString(),
            chiefReviewed: item.reviewed_by_chief_engineer || false,
            masterReviewed: item.reviewed_by_master || false,
          }));
          setFilteredData(reversedData);
        }
        set_page_loader(false);
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
      set_page_loader(false);
    }
  };

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "record_id",
      align: "center",
      key: "record_id",
      sorter: (a, b) => a.record_id - b.record_id,
      render: (record_id, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {record_id}
        </span>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      align: "center",
      key: "date",
      render: (date, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {formatDate(date)}
        </span>
      ),
    },
    {
      title: "Code Letter",
      dataIndex: "code_category",
      align: "center",
      key: "code_category",
      render: (code_category, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {code_category}
        </span>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (created_at, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {formatDate(created_at)}
        </span>
      ),
    },
    {
      title: "Updated Date",
      dataIndex: "updated_at",
      align: "center",
      key: "updated_at",
      render: (updated_at, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {formatDate(updated_at)}
        </span>
      ),
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <span>Confirmed by Chief Engineer</span>
          <Checkbox
            style={{ marginLeft: 8 }}
            checked={filteredData.length > 0 && filteredData.every((item) => item.chiefReviewed)}
            indeterminate={
              filteredData.some((item) => item.chiefReviewed) &&
              !filteredData.every((item) => item.chiefReviewed)
            }
            disabled
          />
        </div>
      ),
      dataIndex: "chief_review",
      align: "center",
      key: "chief_review",
      render: (text, record, index) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Checkbox checked={record.chiefReviewed} disabled />
          <span
            style={{
              marginLeft: 8,
              textDecoration: record?.soft_delete ? "line-through" : "none",
            }}
          >
            Confirmed by Chief Engineer
          </span>
        </div>
      ),
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <span>Reviewed By Master</span>
          <Checkbox
            style={{ marginLeft: 8 }}
            checked={filteredData.length > 0 && filteredData.every((item) => item.masterReviewed)}
            indeterminate={
              filteredData.some((item) => item.masterReviewed) &&
              !filteredData.every((item) => item.masterReviewed)
            }
            disabled
          />
        </div>
      ),
      dataIndex: "master_review",
      align: "center",
      key: "master_review",
      render: (text, record, index) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Checkbox checked={record.masterReviewed} disabled />
          <span
            style={{
              marginLeft: 8,
              textDecoration: record?.soft_delete ? "line-through" : "none",
            }}
          >
            Reviewed By Master
          </span>
        </div>
      ),
    },
    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => (
        <>
          <Tooltip title="View">
            <Button
              type="primary"
              size="small"
              onClick={() => navigate(`/view-oil-record-log-com/${btoa(record?.record_id)}`)}
              style={{ marginRight: "15px" }}
              icon={<EyeFilled />}
            />
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-3">
          <label className="block-label">Select Ship</label>
          <Select
            placeholder="---- Select Ship ----"
            style={{ width: "100%" }}
            value={ship_id}
            onChange={(value) => {
              set_ship_id(value);
              LIST_OIL_RECORD_LOGBOOK_API(value);
            }}
          >
            {ship_table_list?.length > 0 && (
              <>
                {ship_table_list.map((ship) => (
                  <>
                    {!ship.soft_delete && (
                      <>
                        <Select.Option key={ship.id} value={ship.id}>
                          {ship.vessel_name}
                        </Select.Option>
                      </>
                    )}
                  </>
                ))}
              </>
            )}
          </Select>
        </div>
      </div>

      <div className="row" style={{ padding: "10px" }}>
        <div className="col-3" style={{ marginLeft: "5px", alignSelf: "end" }}>
          <div className="theme-content-title text-left">
            <h3>Oil Record Book Information</h3>
          </div>
        </div>
        <div className="col-3"></div>
        <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
          <div className="d-flex align-items-center">
            <Button
              type="primary"
              className="save_btn"
              onClick={() => navigate("/view-audit-trail-oil-com")}
            >
              Audit Trail
            </Button>
          </div>
        </div>
      </div>
      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 10 }}
        rowKey="key"
        loading={page_loader}
        className="custom-table"
      />
    </>
  );
};

export default ListOilRecordLog;
